export default __webpack_public_path__ + "static/media/galerie.2fe17e2d.svg";